module.exports = __webpack_public_path__ + "static/media/southTyrolMountain.fbe11180.png";